import { lazy, Suspense } from 'react';

const LazyLowQualityFacePhoto = lazy(() => import('./LowQualityFacePhoto'));

const LowQualityFacePhoto = () => (
  <Suspense fallback={null}>
    <LazyLowQualityFacePhoto />
  </Suspense>
);

export default LowQualityFacePhoto;
